// Service + checkout-staffing suggestions for the Actions tab, built from the
// proactive findings feed (GET /coach/findings/), not from the €-ranked opportunity
// list — service response has no € figure and we declined to invent one.
//
// A feed row is {FindingId, Kind, Signature, Data: {zone, title, detail, …}}. The tab
// used to read f.kind / f.zone off the row itself, matched nothing, and so never
// showed these cards while the weekly suggestions email (coach/suggestion_digest.py,
// which reads Kind + Data.zone) did. The idea slugs here are the ones that email
// builds, so dismissing / snoozing / tracking one is honoured by both.
//
// Pure and framework-free (unit-tested).

const ZONE_KINDS = ['service_response_pattern', 'service_response_change']
const CHECKOUT_KIND = 'checkout_staffing_pattern'

function flatten(row) {
  const data = (row && row.Data) || {}
  return { ...data, kind: row.Kind || data.kind, signature: row.Signature || data.signature }
}

export function serviceSuggestionsFrom(rows, todayIso) {
  const findings = (rows || []).filter(Boolean).map(flatten)
  const card = (f, extra) => ({
    eur: null,                       // deliberately absent, not zero
    action: f.title,
    why: f.detail || null,
    state: 'considering', confirming: false, pivotDraft: todayIso, snoozeDraft: 14,
    ...extra,
  })

  const fromZones = findings
    .filter((f) => f.zone && ZONE_KINDS.includes(f.kind))
    .map((f) => card(f, {
      idea: `svc:${String(f.zone).toLowerCase().replace(/\s+/g, '-')}`,
      zone: f.zone, leverKind: 'svc', leverLabel: 'Service',
    }))

  // Checkout staffing sits in the SAME block, not a third section: opening a till
  // and covering an aisle are the same kind of decision, and splitting them would
  // give the manager two places to look for "who is where".
  // Store-level, so it has no zone — the waiting zones are the scope for measuring.
  const fromCheckout = findings
    .filter((f) => f.kind === CHECKOUT_KIND)
    .map((f) => card(f, {
      idea: `chk:${String(f.signature || 'checkout').toLowerCase().replace(/[^a-z0-9]+/g, '-')}`,
      zone: 'Checkout', leverKind: 'chk', leverLabel: 'Checkout',
    }))

  return [...fromZones, ...fromCheckout]
}
